import { TableColumn } from './table.column';

export class TableColumnContainer {
  columns: TableColumn[];
  columnIndices = [] as string[];

  public constructor(columns: TableColumn[]) {
    this.setColumns(columns);
  }

  public getDataColumns(): string[] {
    return this.columnIndices;
  }

  public setColumns(columns: TableColumn[]) {
    this.columns = columns;

    if (columns) {
      this.columnIndices.length = 0;
      columns.forEach((column: TableColumn) => {
        this.columnIndices.push(column.column);
      });
    }
  }
  public getColumn(columnId: string): TableColumn {
    for (const column of this.columns) {
      if (column.column === columnId) {
        return column;
      }
    }

    return null;
  }
  public getColumnByIndex(index: number): TableColumn {
    if (this.columns.length <= index) {
      return null;
    } else {
      return this.columns[index];
    }
  }
  public getColumnBySortBy(sortBy: string): TableColumn {
    for (const column of this.columns) {
      if (column._sortBy === sortBy) {
        return column;
      }
    }
    for (const column of this.columns) {
      if (column.column === sortBy) {
        return column;
      }
    }

    return null;
  }
}
